import React from 'react';
import ChatWidget from './components/ChatWidget';
import CheckoutPage from './components/CheckoutPage';
import SuccessPage from './components/SuccessPage';

function App() {
  const path = window.location.pathname;
  const params = new URLSearchParams(window.location.search);

  if (path === '/checkout') {
    const data = params.get('data');
    return <CheckoutPage data={data} />;
  }

  if (path === '/success') {
    const sessionId = params.get('session_id');
    return <SuccessPage sessionId={sessionId} />;
  }

  if (path === '/cancel') {
    return (
      <div style={{ textAlign: 'center', padding: '100px 20px' }}>
        <h1>Payment Cancelled</h1>
        <p>No worries! You can try again anytime.</p>
        <a href="/" style={{ color: '#2563eb', textDecoration: 'underline' }}>Go back home</a>
      </div>
    );
  }

  return (
    <div className="App" style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", color: '#1a1a2e' }}>
      {/* Nav Bar */}
      <nav style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 40px',
        background: '#fff',
        borderBottom: '1px solid #e5e7eb',
        position: 'sticky',
        top: 0,
        zIndex: 100
      }}>
        <div style={{ fontSize: '1.5rem', fontWeight: '800', color: '#2563eb' }}>
          AsliApp
        </div>
        <div style={{ display: 'flex', gap: '24px' }}>
          <a href="#services" style={{ color: '#4b5563', textDecoration: 'none', fontWeight: '500', fontSize: '0.95rem' }}>Services</a>
          <a href="#contact" style={{ color: '#4b5563', textDecoration: 'none', fontWeight: '500', fontSize: '0.95rem' }}>Contact</a>
        </div>
      </nav>

      {/* Hero Section */}
      <header style={{
        background: 'linear-gradient(135deg, #2563eb, #1e40af)',
        color: 'white',
        padding: '80px 20px',
        textAlign: 'center'
      }}>
        <h1 style={{ fontSize: '3rem', marginBottom: '16px', fontWeight: '800' }}>
          Welcome to AsliApp
        </h1>
        <p style={{ fontSize: '1.25rem', opacity: 0.9, maxWidth: '600px', margin: '0 auto', lineHeight: 1.6 }}>
          Your one-stop platform for digital services in the UAE.
          From building websites to delivering food — we've got you covered.
        </p>
      </header>

      {/* Services Section */}
      <section id="services" style={{
        padding: '60px 20px',
        maxWidth: '900px',
        margin: '0 auto'
      }}>
        <h2 style={{ textAlign: 'center', fontSize: '2rem', marginBottom: '40px', fontWeight: '700' }}>
          Our Services
        </h2>

        <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap', justifyContent: 'center' }}>
          {/* Asli Web Service Card — Primary */}
          <div style={{
            flex: '1 1 360px',
            maxWidth: '420px',
            border: '2px solid #2563eb',
            borderRadius: '12px',
            padding: '32px',
            background: '#fff',
            boxShadow: '0 4px 20px rgba(37, 99, 235, 0.15)',
            position: 'relative'
          }}>
            <span style={{
              position: 'absolute',
              top: '-12px',
              left: '24px',
              background: '#2563eb',
              color: '#fff',
              padding: '4px 14px',
              borderRadius: '20px',
              fontSize: '0.75rem',
              fontWeight: '700',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>Live Now</span>
            <h3 style={{ fontSize: '1.5rem', marginBottom: '12px', color: '#1e40af', fontWeight: '700' }}>
              Asli Web Service
            </h3>
            <p style={{ color: '#4b5563', lineHeight: 1.6, marginBottom: '24px' }}>
              Build your professional website in minutes with AI.
              Chat with our assistant, pick a plan, and we handle everything — domain, hosting, and design.
            </p>
            <a
              href="/checkout?data=%7B%22plan%22%3A%22starter%22%7D"
              style={{
                display: 'inline-block',
                background: '#2563eb',
                color: '#ffffff',
                padding: '14px 32px',
                borderRadius: '8px',
                fontSize: '1.1rem',
                fontWeight: '700',
                textDecoration: 'none',
                boxShadow: '0 4px 14px rgba(37, 99, 235, 0.3)',
                transition: 'transform 0.2s, box-shadow 0.2s'
              }}
              onMouseEnter={e => { e.target.style.transform = 'scale(1.05)'; e.target.style.boxShadow = '0 6px 20px rgba(37, 99, 235, 0.4)'; }}
              onMouseLeave={e => { e.target.style.transform = 'scale(1)'; e.target.style.boxShadow = '0 4px 14px rgba(37, 99, 235, 0.3)'; }}
            >
              Build your site for AED 99
            </a>
          </div>

          {/* Asli Delivery App Card — Coming Soon */}
          <div style={{
            flex: '1 1 360px',
            maxWidth: '420px',
            border: '1px solid #e5e7eb',
            borderRadius: '12px',
            padding: '32px',
            background: '#f9fafb',
            position: 'relative',
            opacity: 0.85
          }}>
            <span style={{
              position: 'absolute',
              top: '-12px',
              left: '24px',
              background: '#f59e0b',
              color: '#fff',
              padding: '4px 14px',
              borderRadius: '20px',
              fontSize: '0.75rem',
              fontWeight: '700',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>Coming Soon</span>
            <h3 style={{ fontSize: '1.5rem', marginBottom: '12px', color: '#92400e', fontWeight: '700' }}>
              Asli Delivery App
            </h3>
            <p style={{ color: '#6b7280', lineHeight: 1.6, marginBottom: '24px' }}>
              Order food from your favourite local restaurants and get it delivered fast.
              A delivery experience built for the UAE.
            </p>
            <span style={{
              display: 'inline-block',
              background: '#e5e7eb',
              color: '#6b7280',
              padding: '14px 32px',
              borderRadius: '8px',
              fontSize: '1.1rem',
              fontWeight: '600',
              cursor: 'default'
            }}>
              Stay Tuned
            </span>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer id="contact" style={{
        background: '#1a1a2e',
        color: '#9ca3af',
        padding: '40px 20px',
        textAlign: 'center',
        fontSize: '0.9rem',
        lineHeight: 1.8
      }}>
        <p style={{ color: '#fff', fontWeight: '700', fontSize: '1.1rem', marginBottom: '8px' }}>AsliApp</p>
        <p>Questions? Email us at <a href="mailto:hello@asliapp.com" style={{ color: '#60a5fa' }}>hello@asliapp.com</a></p>
        <p style={{ marginTop: '16px', opacity: 0.6 }}>&copy; {new Date().getFullYear()} AsliApp. All rights reserved.</p>
      </footer>

      <ChatWidget />
    </div>
  );
}

export default App;
